/**
 * Created: 2026-07-11
 * Initial commit: Add mock admin application main component
 * Updated: 2026-08-05 — Replace placeholder with real router/layout,
 * reusing the site app's MainWindow chrome with the admin's own nav list.
 * Updated: 2026-11-03 — Calls message.init(), without which message.error()
 * (e.g. a duplicate control point address) silently does nothing.
 *
 * Admin application root: router + MainWindow chrome + admin nav items.
 */

import { message } from '@homemaster/jslib'
import DashboardIcon from '@mui/icons-material/Dashboard'
import DevicesIcon from '@mui/icons-material/Devices'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { zhCN as muiZhCN } from '@mui/x-date-pickers/locales'
import { LicenseInfo } from '@mui/x-license'
import { zhCN } from 'date-fns/locale'
import { useEffect } from 'react'
import { createBrowserRouter, Navigate } from 'react-router'
import { RouterProvider } from 'react-router/dom'
import MainWindow, { type NavItem } from '../MainWindow'
import IotDevicesPage from '../pages/IotDevicesPage'
import AdminDashboardPage from './AdminDashboardPage'

// register MUI-X license key, expires on Jan. 25, 2027
LicenseInfo.setLicenseKey(
  '64a59fe7cef759ee6dc51c9b876f1d97Tz0xMjM3MzgsRT0xODAwOTIxNTk5MDAwLFM9cHJvLExNPXBlcnBldHVhbCxQVj1RMS0yMDI2LFE9MSxBVD1tdWx0aSxLVj0y',
)

const navItems: NavItem[] = [
  { text: '数据看板', icon: <DashboardIcon />, path: '/dashboard' },
  { text: 'IoT 设备管理', icon: <DevicesIcon />, path: '/iot-devices' },
]

function AdminMainWindow() {
  return <MainWindow navItems={navItems} />
}

const router = createBrowserRouter([
  {
    path: '/',
    element: <AdminMainWindow />,
    children: [
      { index: true, element: <Navigate to="/dashboard" replace /> },
      { path: 'dashboard', element: <AdminDashboardPage /> },
      { path: 'iot-devices', element: <IotDevicesPage /> },
    ],
  },
])

export default function AdminApp() {
  // Mounts the host for message.* toasts and prompts, as AppMain does.
  useEffect(() => {
    message.init()
  }, [])

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={zhCN}
      localeText={muiZhCN.components.MuiLocalizationProvider.defaultProps.localeText}
    >
      <RouterProvider router={router} />
    </LocalizationProvider>
  )
}
